import {UseQueryResult, useQuery} from '@tanstack/react-query';

import {DashboardConfig} from 'app/components/Dashboard/types';
import {api} from 'app/modules/Remote';
import {getLayerKeyFromSourceAndLayer} from 'app/utils/layerUtils';

export function useDashboardConfigs(orgId: string): UseQueryResult<
  {
    [id: string]: DashboardConfig;
  },
  Error
> {
  const queryKey = ['dashboard-configs', orgId];
  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await api.dashboardStats(orgId).getDashboardConfigs();
      const json = await response.toJS();
      return json.data as {[id: string]: DashboardConfig};
    },
    select: (dashboardConfigs) => {
      const adjustedConfigs: {[id: string]: DashboardConfig} = {};

      // Layer Key on the backend is the layer Id on the frontend, adjusting
      // for the frontend format here where layer key is the sourceId and layerId combined.
      for (const [id, config] of Object.entries(dashboardConfigs)) {
        adjustedConfigs[id] = {
          ...config,
          widgets: config.widgets.map((widget) => ({
            ...widget,
            ...('layerKey' in widget
              ? {
                  layerKey: getLayerKeyFromSourceAndLayer(widget.sourceId, widget.layerKey),
                }
              : {}),
          })),
        };
      }

      return adjustedConfigs;
    },
  });
}
